export default class MemberCredit {
    static fromData(data) {
        if (!data) {
            return;
        }

        const memberCredit = new MemberCredit();
        memberCredit.id = data.id;
        memberCredit.name = data.name;
        memberCredit.categoryName = data.categoryName;
        memberCredit.departmentName = data.departmentName;
        memberCredit.activatedAt = data.activatedAt;
        memberCredit.isUnused = data.isUnused;
        memberCredit.isActive = data.isActive;
        memberCredit.used = (data.used.data.numerator / data.used.data.denominator);
        memberCredit.remaining = (data.remaining.data.numerator / data.remaining.data.denominator);
        memberCredit.total = (data.total.data.numerator / data.total.data.denominator);

        Object.seal(memberCredit);
        return memberCredit;
    }
}
